export const ASSESSMENT_TOOL_NAME = "ArmorCode Pentest Management Module";
